export default "__VITE_ASSET__f87cace4__"